<template>
    <div class="container" v-if="!loading">
      <div class="white-frame">
        <div class="title-text mb-3">
          <b>Resumo das informações para acionamento de Seguro</b>
        </div>

             <!-- Section 2: Claim Data and Damaged Goods -->
             <div class="row mb-4">
          <div class="col-12 col-md-6 mb-3">
            <resume-global :objDTO="objDTO" />
          </div>
          <div class="col-12 col-md-6 mb-3">
            <resume-dados-sinistro
              :objDTO="objDTO"
              :events="events"
              :coverages="coverages"
            >
            </resume-dados-sinistro>
          </div>
        </div>

 
        <!-- Section 2: Claim Data and Damaged Goods -->
        <div class="row mb-4">
      
          <div class="col-12 col-md-6 mb-3">
            <div class="output-group h-100">
              <div class="output-title">
                <b>Bens danificados</b>
              </div>
              <div>
                <span>Descrição dos bens:</span>
                <div class="output-textArea">
                  {{ objDTO.Veiculo.Obs }}
                </div>
              </div>
              <div v-if="!showEquipmentData">
                <span>Estimativa de Prejuízo:</span>
                {{ formatCurrency(objDTO.Reserva.ValorReclamado) }}
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 mb-3">
            <div class="output-group h-100">
              <div class="output-title">
                <b>Local do Sinistro</b>
              </div>
              <div>
                <span>Local:</span>
                {{ objDTO.Sinistro.SinistroMorada }}
              </div>
              <div>
                <span>Nº:</span>
                {{ objDTO.Sinistro.SinistroMoradaNrPorta }}
              </div>
              <div>
                <span>Estado:</span>
                {{ objDTO.Sinistro.SinistroDistritoDescripton }}
              </div>
              <div>
                <span>Cidade:</span>
                {{ objDTO.Sinistro.SinistroConcelhoDescription }}
              </div>
              <div>
                <span>Bairro:</span>
                {{ objDTO.Sinistro.SinistroFreguesiaDescription }}
              </div>
              <div>
                <span>Complemento:</span>
                {{ objDTO.Sinistro.SinistroObs }}
              </div>
            </div>
          </div>
        </div>
      
        <!-- Section 3: Locations and Equipment Data -->
        <div class="row mb-4">
    
          <div class="col-12 col-md-6 col-lg-4 mb-3">
            <div class="output-group h-100">
              <div class="output-title">
                <b>Local da Vistoria</b>
              </div>
              <div>
                <span>Contato:</span>
                {{ objDTO.Vistoria.VistoriaLocal.Nome }}
              </div>
              <div>
                <span>Telefone:</span>
                {{ objDTO.Vistoria.VistoriaLocal.Telefone }}
              </div>
              <div>
                <span>Local:</span>
                {{ objDTO.Vistoria.VistoriaLocal.Morada }}
              </div>
              <div>
                <span>Nº:</span>
                {{ objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade }}
              </div>
              <div>
                <span>Estado:</span>
                {{ objDTO.Vistoria.VistoriaLocal.DistritoDescription }}
              </div>
              <div>
                <span>Cidade:</span>
                {{ objDTO.Vistoria.VistoriaLocal.ConcelhoDescription }}
              </div>
              <div>
                <span>Bairro:</span>
                {{ objDTO.Vistoria.VistoriaLocal.FreguesiaDescription }}
              </div>
              <div>
                <span>Complemento:</span>
                {{ objDTO.Vistoria.VistoriaLocal.Obs }}
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4 mb-3" v-if="showEquipmentData">
            <div class="output-group h-100">
              <div class="output-title">
                <b>Dados do Equipamento</b>
              </div>
              <div>
                <span>Tipo:</span>
                {{ objDTO.Veiculo.Modelo }}
              </div>
              <div>
                <span>Marca:</span>
                {{ objDTO.ProcessoGDM.Marca }}
              </div>
              <div>
                <span>Modelo:</span>
                {{ objDTO.ProcessoGDM.Modelo }}
              </div>
              <div>
                <span>Chassi:</span>
                {{ objDTO.Veiculo.NrChassis }}
              </div>
              <div>
                <span>Ano Fabricação:</span>
                {{ objDTO.Veiculo.ModeloAno }}
              </div>
              <div>
                <span>Estimativa de Prejuízo:</span>
                {{ formatCurrency(objDTO.Reserva.ValorReclamado) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Buttons Section -->
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <button
              class="button-base-small btn-gray font-small mx-1"
              @click="voltar"
            >
              Voltar
            </button>
            <button
              class="button-base-small btn-green font-small mx-1"
              @click="finishAviso"
              :disabled="loading"
            >
              Concluir Aviso
            </button>
          </div>
        </div>
      </div>
    </div>

    <loading-state-f-s v-else />
  </template>
  
  <script>
   import ResumeGlobal from '../ResumeGlobal.vue';
  import ResumeDadosSinistro from './shared/ResumeDadosSinistro.vue';
  import LoadingStateFS from '../LoadingStateFS.vue';
  import { createAviso } from '../../api/formMethods';
  import { AREA_NEGOCIO } from '../../utils/constants';
  import {
    formatDate,
    handleAberturaResponseWithUploadDocuments,
  } from '../../utils/helpers';
  
  export default {
    components: {
      ResumeGlobal,
      LoadingStateFS,
      ResumeDadosSinistro,
    },
    props: {
      objDTO: {
        type: Object,
        required: true,
      },
      events: {
        type: Array,
        required: true,
      },
      coverages: {
        type: Array,
        required: true,
      },
      riskUnits: {
        type: Array,
        required: true,
      },
      insuranceObjects: {
        type: Array,
        required: true,
      },
      showEquipmentData: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
      };
    },
    methods: {
      voltar() {
        this.$emit('back', 1);
      },
      formatCurrency(value) {
        if (value === undefined || value === null) return 'R$ 0,00';
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(value);
      },
      async finishAviso() {
        this.loading = true;
  
       try{
        this.objDTO.Sinistro.SinistroData = formatDate(
          this.objDTO.Sinistro.SinistroData
        );
        this.objDTO.Sinistro.ApoliceDataInicio = formatDate(
          this.objDTO.Sinistro.ApoliceDataInicio
        );
        this.objDTO.Sinistro.ApoliceDataFim = formatDate(
          this.objDTO.Sinistro.ApoliceDataFim
        );
        this.objDTO.Sinistro.DataNascimento = formatDate(
          this.objDTO.Sinistro.DataNascimento
        );
  
        // Garante que o ValorEstimadoReparacao seja um número para envio à API
        if (this.objDTO.Reserva.ValorReclamado !== null && 
            this.objDTO.Reserva.ValorReclamado !== undefined) {
          // Converte para número se for string
          this.objDTO.Reserva.ValorReclamado = parseFloat(
            this.objDTO.Reserva.ValorReclamado.toString().replace(/[^\d,-]/g, '').replace(',', '.')
          );
        }

        // Garante que o número de vistoria seja enviado corretamente
        if (!this.objDTO.Vistoria) {
          this.objDTO.Vistoria = {};
        }
        
        if (!this.objDTO.Vistoria.VistoriaLocal) {
          this.objDTO.Vistoria.VistoriaLocal = {};
        }
        
        // Certifica que o número de vistoria não seja undefined ou nulo
        if (this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade === undefined ||
            this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade === null) {
          this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade = '';
        }

        // Verifica se o número de vistoria é uma string vazia e insere um valor padrão se necessário
        if (this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade.trim() === '') {
          console.warn('Número de vistoria não informado. Usando valor padrão.');
          this.objDTO.Vistoria.VistoriaLocal.CodPostalLocalidade = 'S/N';
        }

        this.objDTO.Apolice.UnidadeDeRiscoDescricao = this.riskUnits.find(
          (ru) => ru.RiskUnitId == this.objDTO.Apolice.UnidadeDeRiscoExternalId
        ).Description;
        this.objDTO.Apolice.ObjectoSeguradoDescricao = this.insuranceObjects.find(
          (io) =>
            io.InsuranceObjectId == this.objDTO.Apolice.ObjectoSeguradoExternalId
        ).Description;
  
        const response = await createAviso(this.objDTO, this.coverages);
        handleAberturaResponseWithUploadDocuments(response, AREA_NEGOCIO.PeC);
       }
       catch (error) {
        this.loading = false;
        console.error(error);
       }
        finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .output-group {
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 0.25rem;
    height: 100%;
  }
  
  .output-title {
    margin-bottom: 1rem;
  }
  
  .output-textArea {
    word-break: break-word;
  }
  </style>
  